import React from 'react';
import Highlighter from 'react-highlight-words';
import { MostRecentReview } from './MostRecentReview';
import { Translate } from 'react-localize-redux';
import { connectToUserPreferences } from '../UserPreferences';

class CommunityReviewsTableRow extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			searchText: this.props.searchText,
		};
	}

	sendMessageToOpenTitleModalInParentFrame = event => {
		var sku = event.currentTarget.getAttribute('data-sku');
		var url =
			window.location !== window.parent.location
				? document.referrer
				: document.location.href;
		var jsonData = {
			action: 'openTitleModal',
			sku: sku,
		};
		window.parent.postMessage(JSON.stringify(jsonData), url);
	};

	render() {
		var row = this.props.row;
		var productInfo = row.productInfo[row.key];
		return (
			<div className="column pad-5">
				<div className="column community-reviews-product-image-container">
					<div className="review-image">
						<img
							className="clickable pad-bottom-1"
							src={row.productImages[row.key]}
							title={productInfo.name}
							alt={productInfo.name}
							onClick={
								this.sendMessageToOpenTitleModalInParentFrame
							}
							data-sku={row.key}
						/>
					</div>
					<div className="product-reviews-count">
						{row.reviews.length}{' '}
						{row.reviews.length === 1 ? 'review' : 'reviews'} total
					</div>
				</div>
				<div className="review-product-information column-spaced">
					<div
						onClick={this.sendMessageToOpenTitleModalInParentFrame}
						data-sku={row.key}
						title={productInfo.name}
						className="review-product-title text-large bold acc-font clickable"
						style={{
							color: this.props.userPreferences.fonts
								.accFontOption,
						}}>
						<Highlighter
							highlightStyle={{
								backgroundColor: '#ffc069',
								padding: 0,
							}}
							searchWords={[this.props.searchText]}
							autoEscape
							textToHighlight={row.productInfo[row.key].name}
						/>
					</div>
					{productInfo.hasOwnProperty('author') &&
					productInfo.author.length > 0 ? (
						<div className={`text-medium acc-font ${this.context}`}>
							<Translate
								id="by_author_x"
								data={{ authorName: productInfo.author }}
							/>
						</div>
					) : (
						''
					)}
					<div className="text-medium">EAN: {productInfo.ean}</div>
					{productInfo.hasOwnProperty('supplier') &&
					productInfo.supplier.length > 0 ? (
						<div className="review-product-publisher-information-row text-medium">
							<Translate
								id="published_by_x"
								data={{ publisherName: productInfo.supplier }}
							/>{' '}
							{productInfo.pubDate !== undefined
								? '(' +
								  new Date(
										productInfo.pubDate,
								  ).toLocaleDateString() +
								  ')'
								: ''}
						</div>
					) : (
						''
					)}
					<div className="text-medium">
						{productInfo.formatDescription}
					</div>
				</div>
				<div className="column-spaced">
					<MostRecentReview
						row={this.props.row}
						communityId={this.props.communityId}
						reviewsCreatedDateMaxDaysBack={
							this.props.reviewsCreatedDateMaxDaysBack
						}
						setUserTitleReviewModalState={
							this.props.setUserTitleReviewModalState
						}
					/>
				</div>
			</div>
		);
	}
}

export default connectToUserPreferences(CommunityReviewsTableRow);
